import { TmrBaseResource } from 'stylewhere/api'

export class OperationConfigurations extends TmrBaseResource {
  static endpoint = 'api/v1/operations' //profile
}
